import { Component, OnInit,ElementRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import cloneDeep from 'lodash/cloneDeep';
import { PeticionesService } from '../servicios/httpservice';
import {FilterPlaneadorPipe}from '../pipes/filter-planeador.pipe';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { jsPDF } from 'jspdf';

import { ExcelSerService } from '../servicios/excel-ser.service';
import { DataDBService } from '../servicios/data-db.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-planeador-compras',
  templateUrl: './planeador-compras.component.html',
  styleUrls: ['./planeador-compras.component.css']
})

export class PlaneadorComprasComponent implements OnInit {
  public xmlArticulos: any = [];
  public DatosUsuario: any;
  public arrayEncabezadoOrigen: any;
  public arrayEncabezadoDestino: any;
  public arrayVehiculos: any;
  public origen: number;
  public destino: number;
  public arrayCuerpo: any;
  public sumaVolumen: number = 0;
  public strArticulo: string;
  public intCantidad: number;
  public arrayEncabezados: any;
  public strBusqueda: string = "";
  public almacenOrigen: number = -1;
  public almacenDestino: number = -1;
  public strAlmacenOrigen: string;
  public strAlmacenDestino: string;
  public spiner: boolean = true;
  public contErrores: number = 0;
  public arrayErrores: any;
  public arraySelect: any;
  public numinici: number;
  public numfin: number;
  public arrayInventario: any;
  public dblAvance: number = 0;
  public dblTotalExcedente: number = 0;
  public strLinea: string = ''
  public imgError: boolean = false;
  public intOpcion: number = 1;
  public htmlCode: any;
  public arrayProveedor: any = [];
  public strProveedor: string = '';
  public arrayAlmacenes: any = [];
  public arrayAlmacenesSelectEncabezado: any = [];
  public arrayCallApi:any=[];
  public arrayBusquedaArt:any=[];
  public strBuscar:string='';
  public objOrdenSeleccionada :any;
  public objOfArrayTork:any;
  public arrayTork :any=[{intAlmacen:'1', soldTo:'20005923',shipTo:'20147284'},
  {intAlmacen:'67', soldTo:'20005923',shipTo:'20147782'},
  {intAlmacen:'7', soldTo:'20005923',shipTo:'20147757'},
  {intAlmacen:'3', soldTo:'20005923',shipTo:'20147760'},
  {intAlmacen:'5', soldTo:'20005923',shipTo:'20147761'},
  {intAlmacen:'11', soldTo:'20005923',shipTo:'20147759'},
  {intAlmacen:'53', soldTo:'20005923',shipTo:'20147758'},
  {intAlmacen:'47', soldTo:'20005923',shipTo:'20147751'},
  {intAlmacen:'68', soldTo:'20005923',shipTo:'20148949'},
  {intAlmacen:'18', soldTo:'20005923',shipTo:'20148988'},
  {intAlmacen:'22', soldTo:'20005923',shipTo:'20148987'},
  {intAlmacen:'27', soldTo:'20005923',shipTo:'20148942'},
  {intAlmacen:'37', soldTo:'20005923',shipTo:'20149060'},
  {intAlmacen:'8', soldTo:'20005923',shipTo:'20149059'},
  {intAlmacen:'4', soldTo:'20005923',shipTo:'20148771'},
  {intAlmacen:'31', soldTo:'20005923',shipTo:'20149094'},
  {intAlmacen:'29', soldTo:'20005923',shipTo:'20148944'},
  {intAlmacen:'33', soldTo:'20005923',shipTo:'20148945'},
  {intAlmacen:'32', soldTo:'20005923',shipTo:'20148946'},
  {intAlmacen:'21', soldTo:'20005923',shipTo:'20148947'},
  {intAlmacen:'28', soldTo:'20005923',shipTo:'20148948'},
  {intAlmacen:'9', soldTo:'20005923',shipTo:'20148950'},
  {intAlmacen:'35', soldTo:'20005923',shipTo:'20148951'},
  {intAlmacen:'48', soldTo:'20005923',shipTo:'20148928'},
  {intAlmacen:'58', soldTo:'20005923',shipTo:'20148929'},
  {intAlmacen:'30', soldTo:'20005923',shipTo:'20148930'},
  {intAlmacen:'13', soldTo:'20005923',shipTo:'20148931'},
  {intAlmacen:'20', soldTo:'20005923',shipTo:'20149058'},
  {intAlmacen:'15', soldTo:'20005923',shipTo:'20149092'},
  {intAlmacen:'51', soldTo:'20005923',shipTo:'20149093'},
  {intAlmacen:'50', soldTo:'20005923',shipTo:'20149061'},
  {intAlmacen:'26', soldTo:'20005923',shipTo:'20149503'},
  {intAlmacen:'81', soldTo:'20005923',shipTo:'20158557'}];
  public arrayAccesos:any=[];
  public tagName:any;

  constructor(private indexedDBService: DataDBService, private router: Router,elem: ElementRef, private route: ActivatedRoute, private _excelService: ExcelSerService, private _httpService: PeticionesService, private changeDetectorRef: ChangeDetectorRef,
    private modal: NgbModal,private datePipe: DatePipe) {


      this.tagName = elem.nativeElement.tagName.toLowerCase();
      this.indexedDBService.getItem('arrayResult', (value) => {
        this.arrayAccesos=value?value:[];
        console.log(this.arrayAccesos[0])
        this.DatosUsuario = this.arrayAccesos[0]
        if (this.arrayAccesos.length > 0) {
          console.log(this.arrayAccesos[0])
          this.DatosUsuario = this.arrayAccesos[0]
          this.strArticulo = '';
          this.intCantidad = 0;
          this.strAlmacenOrigen = '';
          this.strAlmacenDestino = '';
          this.route.queryParams.subscribe(params => {
            this.strLinea = params['linea'];
            this.intOpcion = params['opcion'];
          });
          this.fnGetProveedores();
        } else {
          this.router.navigate(['/login']);
        }
      });
  }

  ngOnInit(): void {
    
  }
  
  
  fnGetBusquedaArt(busqueda:string){

    console.log(busqueda);

    this.arrayBusquedaArt =[];

    this._httpService.getLogisticaPlaneador(
      {  strAccion: 'getBusquedaArt',
        strLinea: this.strLinea,
        strOpcion:busqueda,
         strProveedor:this.objOrdenSeleccionada.proveedor
      }).subscribe(result => {
        this.arrayBusquedaArt = result ;
        this.fnAgregarOpciones(); 
       });

  }

  fnAgregarOpciones(){
    this.arrayBusquedaArt.forEach(x => {
      x.strOpcion  = '['+x.strOpcion+']';
      x.arrayOpciones= JSON.parse(x.strOpcion.trim());
      x.objOpcion =x.arrayOpciones?x.arrayOpciones[0]:{strOpcion:"",strNombreOpcion:""};
    });
    console.log(this.arrayBusquedaArt);
  }

  fnAddArt(art:any){
    console.log(art);
    console.log(this.objOrdenSeleccionada);
    let arrayresult = this.arrayEncabezados.find(o=>o.strAlmacen==this.objOrdenSeleccionada.almacen && o.strProveedor==this.objOrdenSeleccionada.proveedor).arrayresult;
    console.log(arrayresult);
    const objetoOriginal = arrayresult[0];
    const copiaObjeto = JSON.parse(JSON.stringify(objetoOriginal));
    copiaObjeto.strArticulo=art.strArticulo;
    copiaObjeto.dblCantidad = art.dblCantidad;
    copiaObjeto.dblPrecio =art.dblPrecio;
    copiaObjeto.strUnidad =art.strUnidad;
    copiaObjeto.strFactor=art.strFactor;
    copiaObjeto.strDescripcion=art.strDescripcion;
    copiaObjeto.strOpcion= art.objOpcion?art.objOpcion.strOpcion:'';
    copiaObjeto.strNombreOpcion= art.objOpcion?art.objOpcion.strNombreOpcion:'';
    arrayresult.push(copiaObjeto);
    console.log(arrayresult);
  }

  fnOpenModal_Add(alm, proveedor){
    this.strBusqueda='';
    this.arrayBusquedaArt =[];
    this.objOrdenSeleccionada={almacen:'',proveedor:''};
    this.objOrdenSeleccionada.almacen=alm.strAlmacen;
    this.objOrdenSeleccionada.proveedor=proveedor;
    console.log(this.objOrdenSeleccionada); 
  }
  fngetalmacenes() {
    if(this.arrayEncabezados){
      this.arrayAlmacenes = this.arrayEncabezados.filter(o => o.arrayresult.length>0);
      this.arrayAlmacenesSelectEncabezado = this.arrayAlmacenes.map(item => cloneDeep(item));
     /*  this.arrayAlmacenesSelectEncabezado = [...this.arrayAlmacenes]; */
      console.log(this.arrayAlmacenes);
      let hash = {};
      this.arrayAlmacenes = this.arrayAlmacenes.filter(o => hash[o.strAlmacen] ? false : hash[o.strAlmacen] = true);
    }
    console.log(this.arrayAlmacenes);
  }

  fnGetProveedores() {
    this.arrayProveedor = [];
    this._httpService.getLogisticaPlaneador(
      {
        strAccion: 'getProveedores',
        strLinea: this.strLinea
      }).subscribe(result => {
        this.arrayProveedor = result.length > 0 ? result : [];
        console.log(this.arrayProveedor);
        this.strProveedor = "-1";
        this.fnGetExcedente();
      });
  }
  fnGetExcedente() {
     this.spiner = true
    this._httpService.getLogisticaPlaneador(
      {
        strAccion: 'getTotalExcedente',
        strLinea: this.strLinea,
        strUsuario: this.DatosUsuario.strUsuario,
        strOpcion: 'compras'
      }).subscribe(result => {
       
        this.dblTotalExcedente = result.length > 0 ? parseInt(result[0].code) : 0;
        console.log('---total excedente-----------');
        console.log(this.dblTotalExcedente);
        // let aumento = this.dblTotalExcedente>500?110:180; 
        let aumento = (this.dblTotalExcedente > 500) ? 25 : 50; //185
        let tiempo = (this.dblTotalExcedente > 500) ? 2000 : 2500;
        if (this.intOpcion==1){
        //dividir en lotes de 200
        let time = 0;
        for (let i = 1; i <= this.dblTotalExcedente; i += aumento) {
          let algo = this.dblTotalExcedente + 2

          let indice2 = (i + aumento) >= (this.dblTotalExcedente) ? this.dblTotalExcedente + 2 : (i + aumento);
          let objX = { indice1: i, indice2: indice2 }
          setTimeout(() => {
            this.arrayCallApi.push({indice1:i, indice2:indice2,result:0});
            this.fnGetTransitos(i, indice2, this.dblTotalExcedente);
          }, time);
          time = time + 3000;
        }
        setTimeout(() => {
          this.spiner = false
          }, time + 1000);
        }
        else {
          this.fnGetTransitos(1, this.dblTotalExcedente, this.dblTotalExcedente);
        }
      }, error => {
          console.log('Error:', error);
          this.fnGetExcedente();
        });
       
  }

  fnGetTransitos(indice1: number, indice2: number, total:number) {
    this.spiner = true;
    let accion = this.intOpcion == 1 ? 'getCompras' : 'getCompras_Todo';
    console.log(accion);
    this._httpService.getLogisticaPlaneador({
      strAccion: accion, intIndice1: indice1, intIndice2: indice2, strLinea: this.strLinea,
      strUsuario: this.DatosUsuario.strUsuario
    }).subscribe(
      result => {
        console.log('-----------------------indices------------------');
        console.log(indice1);
        console.log(indice2);
        console.log(result);
        let res = (result.length > 0 && result.length == 1) ? result[0].code : result.length > 1 ? 220 : 409;
        if (res == 200) {
          this.dblAvance = this.dblAvance + 1;
          let intIndice1=result[0].intIndice1;
          let intIndice2=result[0].intIndice2;
          let aux = this.arrayCallApi.find(o=>o.indice1==intIndice1 && o.indice2==intIndice2);
          aux.result=1;
        }
        else if (res == 220) {
          let intIndice1=result[0].intIndice1;
          let intIndice2=result[0].intIndice2;
          let aux = this.arrayCallApi.find(o=>o.indice1==intIndice1 && o.indice2==intIndice2);
          if (aux){aux.result=1;}
          //validar cuantos marcaron error
          let array_error = this.arrayCallApi.filter(o=>o.result==0);
          if(array_error.length==0){// si no se encontraron errores
            
            console.log('---------FIN--------------EXITOSO------------------');
            console.log(this.arrayCallApi);
            console.log(result);
            this.fngetOrigenDestino(result);
          } //de lo contrario, volver a llamar el metodo
          else {
            
            array_error.push({indice1:total+2,indice2:total+2,result:1});
            this.arrayCallApi.push({indice1:total+2,indice2:total+2,result:1});
            array_error.forEach(value=>{
              this.fnGetTransitos(value.indice1, value.indice2, total)
              
            })
          }
        }
        console.log(this.arrayCallApi);
      },
      error => {
        console.log('Error:', error);
        console.log('---------de nuevo--------------indices------------------');
        console.log(indice1);
        console.log(indice2); 
        this.fnGetTransitos(indice1, indice2, total)
      });
  }
  onAlmacenChange(ind:number,almD:string){
    console.log( this.arrayEncabezados[ind]);
    /* this.arrayEncabezados[ind].strAlmacen = almD; */
    this.arrayAlmacenes.forEach(x => {
      if(almD == x.strAlmacen){
        this.arrayEncabezados[ind].strNombreAlm =x.strNombreAlm;
      }
      
    });
    


  }
  /*fnGetAlmDestino( cuerpo:any){
    
    if (cuerpo.length>0){
      this.arrayEncabezadoDestino=[];
      this.spiner = true;
    this._httpService.getLogisticaPlaneador({strAccion:'getAlmDestinoCompras' }).subscribe(
      result => {
        console.log(result);
        this.arrayEncabezadoDestino=result;
        this.arrayCuerpo=cuerpo;
       if (this.arrayEncabezados && this.arrayCuerpo) {
          this.arrayEncabezados.forEach(element => {
          let arrayresult = this.arrayCuerpo.filter(o => o.strAlm_Origen == element.strAlmacen&&o.strProveedor==element.strProveedor);
          element.arrayresult=arrayresult;
        });
      }
      if (this.arrayEncabezados && this.arrayEncabezados.length > 0) {
        const objetosConArrayResult = this.arrayEncabezados.filter(objeto => objeto.arrayresult && objeto.arrayresult.length > 0);
        console.log(objetosConArrayResult);
        this.imgError = false;
        this.spiner = false;
        this.fnsumarCantidadtotales();
      }else{
        this.fnGetAlmDestino(cuerpo);
      } 
        },
        error => {
          console.log('Error:', error);
          this.fnGetAlmDestino( cuerpo);
   });
    }else{
      this.imgError = true
    }
    
    }*/
  fngetOrigenDestino(cuerpo: any) {  /*getNombresAlmacen*/
    this._httpService.getLogisticaPlaneador({ strAccion: 'getAlmDestinoCompras', strLinea: this.strLinea }).subscribe(
      resultados => {
        this.arrayEncabezados = resultados;
        this.arrayCuerpo = cuerpo;
        console.log(resultados);
        this.arrayEncabezados = resultados.sort((x, y) => x.strProveedor.localeCompare(y.strProveedor));//resultados.sort((x, y) => x.strNombreAlm.localeCompare(y.strNombreAlm));
       
        this.arrayEncabezados.forEach(element => {
          element.fechaEntrega = null;
          let arrayresult = this.arrayCuerpo.filter(o => o.strAlm_Origen == element.strAlmacen && o.strProveedor == element.strProveedor);
          element.arrayresult = arrayresult;
          console.log(element.arrayresult );
        });
        this.imgError = false;
        this.spiner = false;
        console.log(this.arrayEncabezados);
        this.fngetalmacenes();
        this.fnsumarCantidadtotales();
      });
  }

  sumarVolumen(stralm: string): number {
    let arrayResult = this.arrayEncabezados.filter(o => o.strNombreAlm == stralm).map(o => o.arrayresult).flat();
    let suma = arrayResult.reduce((acumulador, registro) => acumulador + registro.dblVolumen, 0);
    return suma;
  }

  sumarPeso(stralm: string): number {
    let arrayResult = this.arrayEncabezados.filter(o => o.strNombreAlm == stralm).map(o => o.arrayresult).flat();
    let suma = arrayResult.reduce((acumulador, registro) => acumulador + registro.dblPeso, 0);
    return suma;
  }

  sumarCantidad(stralm: string, Proveedor: string): number {
    let arrayResult = this.arrayEncabezados.filter(o => o.strNombreAlm == stralm && o.strProveedor == Proveedor).map(o => o.arrayresult).flat();
    let suma = arrayResult.reduce((acumulador, registro) => acumulador + registro.dblCantidad, 0);
    return suma;
  }

  sumarVolumenT(stralm: string): number {
    let arrayResult = this.arrayEncabezados.filter(o => o.strNombreAlm == stralm).map(o => o.arrayresult).flat();
    let suma = arrayResult.reduce((acumulador, registro) => acumulador + (registro.dblVolumen * registro.dblCantidad), 0);
    return suma;
  }
  sumarPesoT(stralm: string): number {
    let arrayResult = this.arrayEncabezados.filter(o => o.strNombreAlm == stralm).map(o => o.arrayresult).flat();
    let suma = arrayResult.reduce((acumulador, registro) => acumulador + (registro.dblPeso * registro.dblCantidad), 0);
    return suma;
  }

  sumarPrecio(stralm: string, Proveedor: string): number {
    let arrayResult = this.arrayEncabezados.filter(o => o.strNombreAlm == stralm && o.strProveedor == Proveedor).map(o => o.arrayresult).flat();
    let suma = arrayResult.reduce((acumulador, registro) => acumulador + registro.dblPrecio, 0);
    return suma;
  }
  sumarPrecioT(stralm: string, Proveedor: string): number {
    let arrayResult = this.arrayEncabezados.filter(o => o.strNombreAlm == stralm && o.strProveedor == Proveedor).map(o => o.arrayresult).flat();
    let suma = arrayResult.reduce((acumulador, registro) => acumulador + (registro.dblPrecio * registro.dblCantidad), 0);
    return suma;
  }
  sumarDescuento(stralm: string): number {
    let arrayResult = this.arrayEncabezados.filter(o => o.strNombreAlm == stralm).map(o => o.arrayresult).flat();
    let suma = arrayResult.reduce((acumulador, registro) => acumulador + registro.dblDescuento, 0);
    return suma;
  }

  /* *ngIf="almD.arrayresult && (almD.arrayresult | filtrarAlmArticulos: strBusqueda).length>0" */
  cerrarModal() {
    this.modal.dismissAll();
  }


  fnQuitarArticulo(indice: number) {
    this.arrayCuerpo.splice(indice, 1);
    const indices = this.arrayCuerpo.findIndex(elemento => elemento.id === indice);
    if (indice !== -1) {
      this.arrayCuerpo.splice(indices, 1);
      this.changeDetectorRef.detectChanges();
    }
  }

  fnAbrirModal(listado) {
    this.modal.open(listado, { size: 'lg' });
  }

  cambiarCantidad(obj, cantidad) {
    obj.dblCantidad = cantidad;
  }
  fnSetOrdenCompra(alm_origen: string, alm_Destino: string, arrayresult: any, almD: any,fecha:any,proveedor:string) {
    let fecharequerida = new Date(fecha);
    let fechaActual = new Date();
    if(fecharequerida<= fechaActual || fecha == null ){
     
      Swal.fire({
        position: 'center',
        icon:  'error' ,
        title: 'Seleccione una fecha valida',
        showConfirmButton: true
      });
    }else{
      console.log(almD);
      let algo = this.arrayEncabezados.filter(o => o.strAlmacen == almD.strAlmacen  && o.strProveedor ==almD.strProveedor);
      algo.arrayresult = [];
      //agrupar articulos y cantidades
      //var xmlArticulos =[]
      this.xmlArticulos=[];
      const arrayCopia = JSON.parse(JSON.stringify(arrayresult));
      arrayCopia.forEach(element =>{ 
        let  aux=this.xmlArticulos.find(o=>o.strArticulo==element.strArticulo && o.strOpcion==element.strOpcion);
        if(aux){
          aux.dblCantidad= aux.dblCantidad+element.dblCantidad; 
        } else{
          this.xmlArticulos.push(element);
        } 
      });
      //SEPARAR POR CONVENIOS RUBBERMAID
      if(this.strLinea=='RUBBERMAID'){
        var arrayConvenio=[];
        this.xmlArticulos.forEach(element =>{ 
          let flag=arrayConvenio.find(o=>o.strEstatusxAlm==element.strEstatusxAlm);
          if(!flag){
            let articulos =this.xmlArticulos.filter(o=>o.strEstatusxAlm==element.strEstatusxAlm);
            arrayConvenio.push({strEstatusxAlm:element.strEstatusxAlm, articulos:articulos});
          }
        });
        console.log( this.xmlArticulos);
        console.log(arrayConvenio);
        let time=2000;
        for (let i = 0; i < arrayConvenio.length; i ++) {
          
          setTimeout(() => {
            let objTransito = { strAccion: 'setOrdenCompra', strAlm_Origen: alm_origen, strAlm_destino: alm_Destino,
            xmlArticulos: arrayConvenio[i].articulos, strLinea: this.strLinea, strFechaRequerida:fecha,
            strProveedor:proveedor, strUsuario: this.DatosUsuario.strUsuario }
            console.log(objTransito);
            this.fnEnviarOrdenCompra(objTransito,almD,fecha);

          }, time);
          time = time + 2000;
        }
      } 
      else {
        let objTransito = { strAccion: 'setOrdenCompra', strAlm_Origen: alm_origen, strAlm_destino: alm_Destino,
        xmlArticulos: this.xmlArticulos, strLinea: this.strLinea, strFechaRequerida:fecha,
        strProveedor:proveedor, strUsuario: this.DatosUsuario.strUsuario }
        console.log(objTransito);
        this.fnEnviarOrdenCompra(objTransito,almD,fecha);
      }
    }
  }

fnEnviarOrdenCompra(objTransito:any,almD:any,fecha:any){
  this.spiner = true;
  this._httpService.getLogisticaPlaneador(objTransito).subscribe(
    result => {
      this.arrayCuerpo=[];
      if(result[0] && result[0].code==200){
         let id= result[0].strMovID;
         Swal.fire({
           position: 'center',
           icon:  'success' ,
           title: 'Se generó Orden de Compra: '+id,
           showConfirmButton: true
         });
         this.spiner= false;
         //eliminamos lo que se envió
         this.arrayEncabezados.forEach((element, index) => {               
           if(element.strAlmacen==almD.strAlmacen && element.strProveedor ==almD.strProveedor){
             this.arrayEncabezados.splice(index, 1);
           }
         });;
         //generamos pdf
         // let id = '123';
         if(this.strLinea!= 'RUBBERMAID'){
           this.fnPdf(id,this.xmlArticulos,fecha, almD);
         }else{
           this.exportToExceljson(objTransito.xmlArticulos,'ORDEN:'+id,'Orden: '+id+ '  Fecha: '+this.datePipe.transform(fecha, 'dd/MM/yyyy')) 
         }
       }
       else {
         let id= result[0].intID;
         Swal.fire({
           position: 'center',
           icon:  'error' ,
           title: 'Ocurrió un error al generar Orden de Compra: ' +id,
           showConfirmButton: true
         });
         this.spiner= false;
         console.log('error')
         console.log(result);
       }
    });  
}
  /******************************************P**D**F************************************************* */
  fnPdf(OrdenC: string, arrayTabla: any,fechareg:any,almd:any){
let strTamOpc =this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"?12:8;
let strTamDesc = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"?50:88;
let strTamLetDesc = 8;
    
console.log(almd)

    let fechaRequerida = this.datePipe.transform(fechareg, 'dd/MM/yyyy');
    let proveedor = arrayTabla[0].strProveedor;
    let fechaActual = new Date();
    let year = fechaActual.getFullYear();
    let month = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
    let day = ('0' + fechaActual.getDate()).slice(-2);
    let fechaActualString = `${day}/${month}/${year}`;
    proveedor = this.arrayProveedor.find(o => o.strProveedor == proveedor);
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });
    // arrayTabla  = arrayTabla.concat([...arrayTabla,...arrayTabla,...arrayTabla,...arrayTabla,...arrayTabla,...arrayTabla,...arrayTabla,...arrayTabla,...arrayTabla,...arrayTabla]);
    /*arrayTabla.splice(arrayTabla.length - 1, 1); */
    console.log(proveedor); 
    let fecha = fechaActualString;
   
    let strEstatusOC = 'PENDIENTE';
    let max_X = 205;
    //const doc = new jsPDF('p', 'mm', 'a4'); 
    const doc = new jsPDF();

    doc.setFontSize(12); //tamaño de fuente
    doc.setTextColor('#000000'); //color de fuente

    doc.text('Compras', 20, 7);
    doc.text('Ecodeli Comercial SA de CV', 145, 7);
    doc.setLineWidth(0.3);
    doc.line(5, 9, max_X, 9); // horizontal line 
    doc.setDrawColor('#000000');
    doc.setLineWidth(.6);
    doc.line(5, 12, max_X, 12); // y= 35

    let text1 = 'Orden Compra  ' + OrdenC;
    doc.text(text1, 5, 18);
    doc.text(strEstatusOC, 80, 18);
 
    doc.text(fecha, 170, 18);

    doc.line(5, 21, max_X, 21); // y= 60
    doc.setFontSize(10);
    doc.text('Datos Proveedor', 24, 28);
    doc.text('Datos Facturación', 100, 28);
    doc.text('Datos Entrega', 165, 28);

    const startX = 5;
    const startY = 31;
    const endX = 205; // El valor de max_X debe ser definido por ti
    const endY = 80;

    // Dibujar el rectángulo
    doc.rect(startX, startY, endX - startX, endY - startY);

    // Calcular las coordenadas de las divisiones
    const divisionWidth = (endX - startX) / 3;
    const division1X = startX + divisionWidth;
    const division2X = startX + 2 * divisionWidth;

    // Dibujar las líneas divisorias
    doc.line(division1X + 10, startY, division1X + 10, endY);
    doc.line(division2X + 10, startY, division2X + 10, endY);


    //PROVEEDOR
    doc.setFontSize(8);
    doc.text('Proveedor:', 7, 35);
    doc.setFont('helvetica', 'bold');
    const text = proveedor.strNombre;
    const x = 22;
    const y = 35;
    const maxWidth = 55; // Ancho máximo permitido antes de pasar a la siguiente línea
    const lines = doc.splitTextToSize(text, maxWidth);
    doc.text(lines, x, y);
    doc.setFont('helvetica', 'normal');
    //Dirección
    doc.text('Dirección:', 7, 42); //doc.text('Dirección:'+'AV. JAIME BALMES NO. 8, INT. PISO 9 #11510', 6, 43);
    doc.setFont('helvetica', 'bold');
    const text3 = proveedor && proveedor.strDireccion ? proveedor.strDireccion : '' +' '+ proveedor && proveedor.strNumero? proveedor.strNumero:'';
    const x1 = 22;
    const y1 = 42;
    const maxWidth1 = 55; // Ancho máximo permitido antes de pasar a la siguiente línea
    const lines1 = doc.splitTextToSize(text3, maxWidth1);
    doc.text(lines1, x1, y1);
    doc.setFont('helvetica', 'normal');
    //COLONIA
    doc.text('Colonia:', 7, 49); //doc.text('Dirección:'+'AV. JAIME BALMES NO. 8, INT. PISO 9 #11510', 6, 43);
    doc.setFont('helvetica', 'bold');
    const text4 = proveedor && proveedor.strColonia ? proveedor.strColonia :'';
    const x2 = 22;
    const y2 = 49;
    const maxWidth2 = 55; // Ancho máximo permitido antes de pasar a la siguiente línea
    const lines2 = doc.splitTextToSize(text4, maxWidth2);
    doc.text(lines2, x2, y2);
    doc.setFont('helvetica', 'normal');
    //poblacion
    doc.text('Población:', 7, 56); //doc.text('Dirección:'+'AV. JAIME BALMES NO. 8, INT. PISO 9 #11510', 6, 43);
    doc.setFont('helvetica', 'bold');
    const text5 = proveedor && proveedor.strPoblacion ? proveedor.strPoblacion :'';
    const x3 = 22;
    const y3 = 56;
    const maxWidth3 = 55; // Ancho máximo permitido antes de pasar a la siguiente línea
    const lines3 = doc.splitTextToSize(text5, maxWidth3);
    doc.text(lines3, x3, y3);
    doc.setFont('helvetica', 'normal');

    doc.text('C.P.:', 7, 63); //doc.text('Dirección:'+'AV. JAIME BALMES NO. 8, INT. PISO 9 #11510', 6, 43);
    doc.setFont('helvetica', 'bold');
    const text6 =proveedor && proveedor.strCodigoPostal ? proveedor.strCodigoPostal: '';
    const x4 = 22;
    const y4 = 63;
    const maxWidth4 = 55; // Ancho máximo permitido antes de pasar a la siguiente línea
    const lines4 = doc.splitTextToSize(text6, maxWidth4);
    doc.text(lines4, x4, y4);
    doc.setFont('helvetica', 'normal');

    doc.text('Telefono:', 7, 70); //doc.text('Dirección:'+'AV. JAIME BALMES NO. 8, INT. PISO 9 #11510', 6, 43);
    doc.setFont('helvetica', 'bold');
    const text7 =proveedor && proveedor.strTelefono ? proveedor.strTelefono: '';
    const x5 = 22;
    const y5 = 70;
    const maxWidth5 = 55; // Ancho máximo permitido antes de pasar a la siguiente línea
    const lines5 = doc.splitTextToSize(text7, maxWidth5);
    doc.text(lines5, x5, y5);
    doc.setFont('helvetica', 'bold');

    doc.text('ECODELI COMERCIAL SA DE CV', 84, 35);
    doc.text('AV. RESTAURADORES OTE. 1001 INT 2', 84, 45);
    doc.text('COL. LOS ARCOS', 84, 55);
    doc.text('C.P. 37490 LEON, MEX.', 84, 65);
    doc.text('TEL. (477)7889800', 84, 72);
    doc.text('R.F.C. ECO061122F78', 84, 78);

    doc.setFontSize(7);
    doc.text((almd && almd.strNombreAlm ? almd.strNombreAlm: '' ).toString(), 150, 35);
    doc.text((almd && almd.strDireccion ? almd.strDireccion: '' ).toString(), 150, 45);
    doc.text((almd && almd.strColonia ? almd.strColonia :'').toString(), 150, 55);
    doc.text((almd && almd.strPoblacion ? almd.strPoblacion :'').toString(), 150, 65);
    doc.text('C.P.:'+' '+ (almd && almd.strCodigoPostal ? almd.strCodigoPostal : '' ).toString(), 150, 72);
    doc.text('Estado: '+(almd && almd.strEstado?almd.strEstado : '').toString(), 150, 78);
    // Agregar contenido en cada división


   

  if(this.strLinea == 'TORK'){
    this.objOfArrayTork = this.arrayTork.find(objeto => objeto.intAlmacen == almd.strAlmacen);
    console.log(this.objOfArrayTork)
  if(this.objOfArrayTork ){

    doc.rect(5, 80, 205 - 5, 87 - 80);
    doc.line(87, 80, 87, 87);
      /*  doc.line(division2X + 10, 85, division2X + 10, 90); */

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text('SOLD TO:', 12, 85);
    doc.setFont('helvetica', 'bold');
    doc.text(this.objOfArrayTork.soldTo, 27, 85);

    doc.setFont('helvetica', 'normal');
    doc.text('SHIP TO:', 90, 85);
    doc.setFont('helvetica', 'bold');
    doc.text(this.objOfArrayTork.shipTo, 114, 85);
  }

    }
  // Agregar contenido en cada división
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.text('Concepto:', 12, 90);
  doc.setFont('helvetica', 'bold');
  doc.text('COMPRAS NACIONALES', 27, 90);

  doc.setFont('helvetica', 'normal');
  doc.text('Fecha Requerida:', 90, 90);
  doc.setFont('helvetica', 'bold');
  doc.text(fechaRequerida, 114, 90);


  

if(this.strLinea == 'KIMBERLY'){
doc.setFont('helvetica', 'normal');
    doc.text('SOLD TO: ', 150, 88);
    doc.setFont('helvetica', 'bold');
    doc.text('20005923', 165, 88);
    
doc.setFont('helvetica', 'normal');
    doc.text('SHIP TO: ', 150, 93);
    doc.setFont('helvetica', 'bold');
    doc.text('20147284', 165, 93);
}
    let tamaniotabla = arrayTabla.length;
    /////////////////////////////////////////variables para modificar tabla/////////////////////
    //lineas de la tabla en el eje x 
    const linexEndArticulo = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"?37: 39;
    /* ///////////////////////////////// */
    /* estas variables solo funcionan cuando la linea es kimberly o  blue tissue o tork */
    const linexEndDescuentos = 140;
    const linexEndCosTeorico = 162;
    const linexEndPrecioFact = 183;
    /* //////////////////////////////// */
    const linexEndDesc = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"?92:132;
    const linexEndcantidad = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"? 107: 149;
    const linexEndUnidad = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"? 123: 166;
    const linexEndCosto = 185;
    const lineYpage1 = 109;
    const lineYpagex = 16;

    // comienzo de cada titulo en el eje x
    const tituloArtx = 6;
    const tituloDescripx = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"?41:43;
    const TitulodDescuentosx = 124; //92 108 124
    const TituloCosTeoricox = 144;
    const TituloPrecioFactx = 165;

    const titulCantidadx = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE" ||this.strLinea == "TORK"? 92 :134;
    const titulUnidadx =this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE" ||this.strLinea == "TORK"? 108: 151;

    const titulCostox = 170;
    const titulImportex = 187;

    // comienzo de datos en el eje x
    const datosArtx = 6;
    const datosDescripx = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"?39:42;
    // const datosOpcionx = 116;
    const datosDescuentos = 125;
    const datosCosTeorico = 142;
    const datosPrecioFact = 165;

    const datosCantidadx = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE" ||this.strLinea == "TORK"? 94 :135 ;
    const datosUnidadx = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE" ||this.strLinea == "TORK"? 109:152;

    const datosCostox = 169;
    const datosImportex = this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE" ||this.strLinea == "TORK"? 185:186 ;



    if (tamaniotabla <= 6) {
      doc.setFont('helvetica', 'normal');
      doc.setTextColor('#000000');
      var tablay = 102;
      var tablayLine = 115;
      doc.setDrawColor('#000000');

       

      for (let i = 0; i < arrayTabla.length; i++) {
        doc.setLineWidth(.3);
        doc.line(5, tablayLine, max_X, tablayLine);
        tablay = tablay + 16;
        tablayLine = tablayLine + 16;
       // tablay = tablay + 8;
        // tablayLine = tablayLine + 8;
      
        doc.text("C.Fab:",datosArtx  , tablay);
        doc.setFont('helvetica', 'bold');
        doc.text(arrayTabla[i].strClaveFabricante.toString(),datosArtx+9  , tablay);
        doc.setFont('helvetica', 'normal');
        doc.text("Articulo:",datosArtx  , tablay+strTamOpc);
        doc.setFont('helvetica', 'bold');
        doc.text(arrayTabla[i].strArticulo.toString(),datosArtx+12 , tablay +strTamOpc);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(strTamLetDesc);
        const text10 = arrayTabla[i].strDescripcion.toString();
        const x8 = datosDescripx;
        const y8 = tablay;
        const maxWidth8 = strTamDesc; // Ancho máximo permitido antes de pasar a la siguiente línea
        const lines8 = doc.splitTextToSize(text10, maxWidth8);
        doc.text(lines8, x8, y8);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'bold');
        doc.text(arrayTabla[i].strUnidad.toString(),  datosUnidadx, tablay);
        doc.text(doc.splitTextToSize(arrayTabla[i].strNombreOpcion, strTamDesc), x8, y8+strTamOpc);
        doc.text("" + (arrayTabla[i].dblCantidad % 1==0?arrayTabla[i].dblCantidad.toString():arrayTabla[i].dblCantidad.toFixed(2)),datosCantidadx  , tablay);
        doc.text("" + formatter.format(arrayTabla[i].dblCantidad * arrayTabla[i].dblPrecio) , datosImportex, tablay);
        doc.setFont('helvetica', 'normal');

       
        if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
          let PrecioFactura= 0;
          PrecioFactura = arrayTabla[i].dblPrecio - ((arrayTabla[i].dblDescuento / 100)* arrayTabla[i].dblPrecio) 
          doc.setFont('helvetica', 'bold');
          doc.text(arrayTabla[i].dblDescuento.toString(),datosDescuentos , tablay);
          doc.setFont('helvetica', 'normal');
          doc.text("" + formatter.format(arrayTabla[i].dblPrecio),datosCosTeorico , tablay);
          doc.text("" + formatter.format(PrecioFactura),datosPrecioFact , tablay);
        }

        
        if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
          doc.text("" + formatter.format(arrayTabla[i].dblPrecio) , datosCostox, tablay);
        }
      }
      var totaly = tablayLine;
      const startX1 = 5;
      const startY1 = 105;
      const endX1 = 205; // El valor de max_X debe ser definido por ti
      var endY1 = totaly;
      // Calcular las coordenadas de las divisiones
      const divisionWidth1 = (endX1 - startX1) / 4;
      const division1X1 = startX1 + divisionWidth1;
      const division2X1 = division1X1 + divisionWidth1;
      // Dibujar las líneas divisorias
      doc.line(linexEndArticulo, startY1, linexEndArticulo, endY1);
      doc.line(linexEndDesc, startY1, linexEndDesc, endY1);

      if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
        doc.line(linexEndDescuentos, startY1, linexEndDescuentos, endY1);
        doc.line(linexEndCosTeorico, startY1, linexEndCosTeorico, endY1);
        doc.line(linexEndPrecioFact, startY1, linexEndPrecioFact, endY1);
      }

      
     // doc.line(linexEndOpcion, startY1, linexEndOpcion, endY1);
      doc.line(linexEndUnidad, startY1, linexEndUnidad, endY1);
      doc.line(linexEndcantidad, startY1, linexEndcantidad, endY1);
      if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
        doc.line(linexEndCosto, startY1, linexEndCosto, endY1);
      }
    
      // Dibujar el rectángulo
      doc.rect(startX1, startY1, endX1 - startX1, endY1 - startY1);
      doc.setDrawColor('#dbe1e8');
      doc.setLineWidth(10);
      doc.line(4.7, 110, max_X + .3, 110);
      doc.setTextColor('#3d6b87');
      doc.setFont('helvetica', 'bold');
      doc.text('Articulo', tituloArtx, lineYpage1+2);
      doc.text('Descripcion', tituloDescripx, lineYpage1+2);
      if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
        const tittleDes = doc.splitTextToSize('Descuento', 16);
        doc.text(tittleDes, TitulodDescuentosx, lineYpage1+2);
        const tittleDes1 = doc.splitTextToSize('Costo Teorico', 15);
        doc.text(tittleDes1, TituloCosTeoricox, lineYpage1+2);
        const tittleDes2 = doc.splitTextToSize('Precio Factura', 17);
        doc.text(tittleDes2, TituloPrecioFactx-2, lineYpage1+2);
      }
     // doc.text('Opcion', titulOpcionx, lineYpage1);
      doc.text('Cantidad', titulCantidadx, lineYpage1+2);
      doc.text('Unidad',titulUnidadx , lineYpage1+2);

      if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
        doc.text('Precio', titulCostox, lineYpage1+2);
      }
     
      doc.text('Importe', titulImportex, lineYpage1+2);
      doc.setFontSize(12);
      doc.setTextColor('#000000');
      doc.setFont('helvetica', 'bold');
      let precioporArt = 0,precioTotal = 0,impuestos=0;
      arrayTabla.forEach(o => {
        precioporArt =  o.dblCantidad * o.dblPrecio;
        precioTotal =  precioporArt  + precioTotal;
      });
      impuestos = precioTotal * 0.16;
     
      doc.text('Importe:', 127, endY1 + 10);
      doc.text('' + formatter.format(precioTotal), 152, endY1 + 10);// doc.text('$' + (precioTotal.toFixed(2)).toString(), 152, endY1 + 10); 
      doc.text('Impuestos:', 127, endY1 + 17);
      doc.text('' + formatter.format(impuestos), 152, endY1 + 17);
      doc.text('Total:', 127, endY1 + 24);
      doc.text('' +  formatter.format(precioTotal + impuestos), 152, endY1 + 24);
      
      let linyTopTittle = endY1 + 10;
      let linedata = linyTopTittle +13,arraySumas:any=[];

      arraySumas = this.obtenerElementosUnicos(arrayTabla);
      console.log('unidades');
      console.log(arraySumas);
      
      arraySumas.forEach( x => {
        arrayTabla.forEach( obj => {
        if(x.strUnidad.trim() === obj.strUnidad.trim()){
          x.intCantidad =  x.intCantidad + obj.dblCantidad
        }
        });
      });
      doc.setLineWidth(10);
      doc.setDrawColor('#dbe1e8');
      doc.line(10, linyTopTittle , 110, linyTopTittle);

      doc.setDrawColor('#000000');
      doc.setLineWidth(.2);
      /* doc.line(10, linedata-8 , 110, linedata-8); */
    
      doc.setFontSize(7);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor('#3d6b87');
      doc.text('Unidades', 28,linyTopTittle+2 );
      doc.text('Cantidades', 63, linyTopTittle+2);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor('#000000');
      let textUnidadesY=linyTopTittle+10;

      textUnidadesY = textUnidadesY-2;
      linedata = linedata - 3;

      //arraySumas = arraySumas.concat([...arraySumas,...arraySumas,...arraySumas]);//arrayTabla.concat([...arrayTabla]);
      for(let i = 0 ; i< arraySumas.length;i++){
        doc.text(arraySumas[i].strUnidad,31 ,textUnidadesY);
        doc.text(arraySumas[i].intCantidad.toString(),68 ,textUnidadesY);
        doc.line(10, linedata , 110, linedata);
        linedata= linedata+6;
        textUnidadesY =textUnidadesY +6;
        if(textUnidadesY>285 ){
          doc.addPage()
          textUnidadesY = 10;
          linedata = 13;
        }
      }
      if(textUnidadesY+54>285 ){
        doc.addPage()
        textUnidadesY=10;
      }else{
        textUnidadesY = textUnidadesY+ 7
      }
     // doc.addPage()
   
      doc.setDrawColor('#CFCFCF');
      doc.setLineWidth(55);
      doc.line(5, textUnidadesY+23, 200, textUnidadesY+23);
      doc.setFont('helvetica', 'bold');
      doc.text("** NOTA IMPORTANTE **",10 ,textUnidadesY);
      doc.setFont('helvetica', 'normal');
      doc.text("Favor de anexar copia de esta Orden de Compra a la Factura.",10 ,textUnidadesY+5);
      doc.text("Como parte del desarrollo de nuestros Proveedores, Ecodeli Comercial evalua los aspectos a la entrega de:",10 ,textUnidadesY+10);
      doc.text("- Cantidad,",10 ,textUnidadesY+15);
      doc.text("- Precio, ",10 ,textUnidadesY+20);
      doc.text("- Características: Coherencia entre descripción en factura y producto físico entregado,",10 ,textUnidadesY+25);
      doc.text("- Tiempo de Entrega.",10 ,textUnidadesY+30);
      doc.text("* Para productos químicos: Anexar Certificado de Calidad. ",10 ,textUnidadesY+37);
      doc.text("* Tolerancia en cantidad: mas/menos 2% ",10 ,textUnidadesY+42);
      doc.text("* HORARIO DE RECEPCIÓN DE MATERIALES: LUNES A VIERNES DE 8:30 A 13:30 HRAS.",10 ,textUnidadesY+47);
      doc.setDrawColor('#000000');
      console.log("Tamaño altura = "+ textUnidadesY+47)
    } 
    else ////////mas de  una hoja
    {
      doc.setFont('helvetica', 'normal');
      doc.setTextColor('#000000');
      var tablay = 102;
      var tablayLine = 115;
      doc.setDrawColor('#000000');
      for (let i = 0; i < 6; i++) {
        doc.setLineWidth(.3);
        doc.line(5, tablayLine, max_X, tablayLine);
        tablay = tablay + 16;
        tablayLine = tablayLine + 16;
       
        doc.text("C.Fab:",datosArtx  , tablay);
        doc.setFont('helvetica', 'bold');
        doc.text(arrayTabla[i].strClaveFabricante.toString(),datosArtx+strTamOpc  , tablay);
        doc.setFont('helvetica', 'normal');
        doc.text("Articulo:",datosArtx  , tablay+strTamOpc-1);
        doc.setFont('helvetica', 'bold');
        doc.text(arrayTabla[i].strArticulo.toString(),datosArtx+12 , tablay +strTamOpc-1);
        doc.setFont('helvetica', 'normal');
        const text10 = arrayTabla[i].strDescripcion.toString();
        const x8 = datosDescripx;
        const y8 = tablay;
        const maxWidth8 = strTamDesc; // Ancho máximo permitido antes de pasar a la siguiente línea
        const lines8 = doc.splitTextToSize(text10, maxWidth8);
        doc.text(lines8, x8, y8);
        doc.setFont('helvetica', 'bold');
        doc.text("" + (arrayTabla[i].dblCantidad % 1==0?arrayTabla[i].dblCantidad.toString():arrayTabla[i].dblCantidad.toFixed(2)), datosCantidadx , tablay);
        doc.text(doc.splitTextToSize(arrayTabla[i].strNombreOpcion, strTamDesc), x8, y8+strTamOpc-1);
        doc.text(arrayTabla[i].strUnidad.toString(),datosUnidadx , tablay);
        doc.text("" + formatter.format(arrayTabla[i].dblCantidad * arrayTabla[i].dblPrecio), datosImportex, tablay);
        doc.setFont('helvetica', 'normal');

        if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
          let PrecioFactura= 0;
          PrecioFactura = arrayTabla[i].dblPrecio - ((arrayTabla[i].dblDescuento / 100)* arrayTabla[i].dblPrecio) 
          doc.setFont('helvetica', 'bold');
          doc.text(arrayTabla[i].dblDescuento.toString(),datosDescuentos , tablay);
          doc.setFont('helvetica', 'normal');
          doc.text("" + formatter.format(arrayTabla[i].dblPrecio),datosCosTeorico , tablay);
          doc.text("" + formatter.format(PrecioFactura),datosPrecioFact , tablay);
        }
   
        
        if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
          doc.text("" + formatter.format(arrayTabla[i].dblPrecio) , datosCostox, tablay);
        }
      }
      var totaly = tablayLine;
      const startX1 = 5;
      const startY1 = 105;
      const endX1 = 205; // El valor de max_X debe ser definido por ti
      var endY1 = totaly;
      // Calcular las coordenadas de las divisiones
      const divisionWidth1 = (endX1 - startX1) / 4;
      const division1X1 = startX1 + divisionWidth1;
      const division2X1 = division1X1 + divisionWidth1;
      // Dibujar las líneas divisorias
      doc.line(linexEndArticulo, startY1, linexEndArticulo, endY1);
      doc.line(linexEndDesc, startY1, linexEndDesc, endY1);
      if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
        doc.line(linexEndDescuentos, startY1, linexEndDescuentos, endY1);
        doc.line(linexEndCosTeorico, startY1, linexEndCosTeorico, endY1);
        doc.line(linexEndPrecioFact, startY1, linexEndPrecioFact, endY1);
      }
     // doc.line(linexEndOpcion, startY1, linexEndOpcion, endY1);
      doc.line(linexEndUnidad, startY1, linexEndUnidad, endY1);
      doc.line(linexEndcantidad, startY1, linexEndcantidad, endY1);
      if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
        doc.line(linexEndCosto, startY1, linexEndCosto, endY1);
      }
      
      // Dibujar el rectángulo
      doc.rect(startX1, startY1, endX1 - startX1, endY1 - startY1);
      doc.setDrawColor('#dbe1e8');
      doc.setLineWidth(10);
      doc.line(4.7, 110, max_X + .3, 110);
      doc.setTextColor('#3d6b87');
      doc.setFont('helvetica', 'bold');
      doc.text('Articulo', tituloArtx, lineYpage1);
      doc.text('Descripcion', tituloDescripx, lineYpage1);
      //doc.text('Opcion', titulOpcionx, lineYpage1);
      if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
        const tittleDes = doc.splitTextToSize('Descuento', 16);
        doc.text(tittleDes, TitulodDescuentosx, lineYpage1);
        const tittleDes1 = doc.splitTextToSize('Costo Teorico', 15);
        doc.text(tittleDes1, TituloCosTeoricox, lineYpage1);
        const tittleDes2 = doc.splitTextToSize('Precio Factura', 17);
        doc.text(tittleDes2, TituloPrecioFactx-2, lineYpage1);
      }
      doc.text('Cantidad',titulCantidadx , lineYpage1);
      doc.text('Unidad', titulUnidadx, lineYpage1);
      if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
        doc.text('Precio', titulCostox, lineYpage1);
      }
      
      doc.text('Importe', titulImportex, lineYpage1);
      doc.addPage()
      doc.setTextColor('#000000');
      doc.setDrawColor('#000000');
      doc.setFont('helvetica', 'normal');
      tablay = 9;
      tablayLine = 20.8;
      var iniciopage2 = 6;
      for (let i = 6; i < arrayTabla.length; i++) {
        if (i == iniciopage2 + 12){
          var totaly = tablayLine;
          const startX2 = 5;
          const startY2 = 15;
          const endX2 = 205; // El valor de max_X debe ser definido por ti
          var endY1 = totaly;
          // Calcular las coordenadas de las divisiones
          const divisionWidth2 = (endX2 - startX2) / 4;
          const division1X2 = startX2 + divisionWidth2;
          const division2X2 = division1X2 + divisionWidth2;
          // Dibujar las líneas divisorias
          doc.line(linexEndArticulo, startY2, linexEndArticulo, endY1);
          doc.line(linexEndDesc, startY2, linexEndDesc, endY1);
          if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
            doc.line(linexEndDescuentos, startY2, linexEndDescuentos, endY1);
            doc.line(linexEndCosTeorico, startY2, linexEndCosTeorico, endY1);
            doc.line(linexEndPrecioFact, startY2, linexEndPrecioFact, endY1);
          }
         // doc.line(linexEndOpcion, startY2, linexEndOpcion, endY1);
          doc.line(linexEndUnidad, startY2, linexEndUnidad, endY1);
          doc.line(linexEndcantidad, startY2, linexEndcantidad, endY1);
          if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
            doc.line(linexEndCosto, startY2, linexEndCosto, endY1);
          }
    
          // Dibujar el rectángulo
          doc.rect(startX2, startY2, endX2 - startX2, endY1 - startY2);
          doc.setDrawColor('#dbe1e8');
          doc.setLineWidth(10);
          doc.line(4.7, 15, max_X + .3, 15);
          doc.setTextColor('#3d6b87');
          doc.setFont('helvetica', 'bold');
          doc.text('Articulo', tituloArtx, lineYpagex);
          doc.text('Descripcion', tituloDescripx, lineYpagex);
          if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
            const tittleDes = doc.splitTextToSize('Descuento', 16);
            doc.text(tittleDes, TitulodDescuentosx, lineYpagex);
            const tittleDes1 = doc.splitTextToSize('Costo Teorico', 15);
            doc.text(tittleDes1, TituloCosTeoricox, lineYpagex-1);
            const tittleDes2 = doc.splitTextToSize('Precio Factura', 17);
            doc.text(tittleDes2, TituloPrecioFactx-2, lineYpagex-1);
          }
         // doc.text('Opcion', titulOpcionx, lineYpagex);
          doc.text('Cantidad',titulCantidadx , lineYpagex);
          doc.text('Unidad',titulUnidadx , lineYpagex);
          if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
            doc.text('Precio', titulCostox, lineYpagex);
          }
         
          doc.text('Importe', titulImportex, lineYpagex);
          doc.setTextColor('#000000');
          doc.setDrawColor('#000000');
          doc.setFont('helvetica', 'normal');
          doc.addPage()
          tablay = 9;
          tablayLine = 20.8;
          iniciopage2 = iniciopage2 + 12;

        }
        doc.setLineWidth(.3);
        if (tablayLine > 21) {
          doc.line(5, tablayLine, max_X, tablayLine);
        }
        tablay = tablay + 16;
        tablayLine = tablayLine + 16;
      
        doc.text("C.Fab:",datosArtx  , tablay);
        doc.setFont('helvetica', 'bold');
        doc.text(arrayTabla[i].strClaveFabricante.toString(),datosArtx+strTamOpc  , tablay);
        doc.setFont('helvetica', 'normal');
        doc.text("Articulo:",datosArtx  , tablay+strTamOpc-1);
        doc.setFont('helvetica', 'bold');
        doc.text(arrayTabla[i].strArticulo.toString(),datosArtx+12 , tablay +strTamOpc-1);
        doc.setFont('helvetica', 'normal');
        const text10 = arrayTabla[i].strDescripcion.toString();
        const x8 = datosDescripx;
        const y8 = tablay;
        const maxWidth8 = strTamDesc; // Ancho máximo permitido antes de pasar a la siguiente línea
        const lines8 = doc.splitTextToSize(text10, maxWidth8);
        doc.text(lines8, x8, y8);
        doc.setFont('helvetica', 'bold');
        doc.text(doc.splitTextToSize(arrayTabla[i].strNombreOpcion, strTamDesc), x8, y8+strTamOpc-1);
        doc.text(arrayTabla[i].strUnidad.toString(),  datosUnidadx, tablay);
       
        doc.text("" + (arrayTabla[i].dblCantidad % 1==0?arrayTabla[i].dblCantidad.toString():arrayTabla[i].dblCantidad.toFixed(2)),datosCantidadx  , tablay);
        doc.text("" + formatter.format(arrayTabla[i].dblCantidad * arrayTabla[i].dblPrecio), datosImportex, tablay);
        doc.setFont('helvetica', 'normal');
        
        if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
          let PrecioFactura= 0;
          PrecioFactura = arrayTabla[i].dblPrecio - ((arrayTabla[i].dblDescuento / 100)* arrayTabla[i].dblPrecio) 
          doc.setFont('helvetica', 'bold');
          doc.text(arrayTabla[i].dblDescuento.toString(),datosDescuentos , tablay);
          doc.setFont('helvetica', 'normal');
          doc.text("" + formatter.format(arrayTabla[i].dblPrecio),datosCosTeorico , tablay);
          doc.text("" + formatter.format(PrecioFactura),datosPrecioFact , tablay);
        }
      
       
        if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
          doc.text("" + formatter.format(arrayTabla[i].dblPrecio) , datosCostox, tablay);
        }
      
        
      }
      var totaly = tablayLine;
      const startX2 = 5;
      const startY2 = 15;
      const endX2 = 205; // El valor de max_X debe ser definido por ti
      var endY1 = totaly;
      // Calcular las coordenadas de las divisiones
      const divisionWidth2 = (endX2 - startX2) / 4;
      const division1X2 = startX2 + divisionWidth2;
      const division2X2 = division1X2 + divisionWidth2;
      // Dibujar las líneas divisorias
      doc.line(linexEndArticulo, startY2, linexEndArticulo, endY1);
      doc.line(linexEndDesc, startY2, linexEndDesc, endY1);
      if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
        doc.line(linexEndDescuentos, startY2, linexEndDescuentos, endY1);
        doc.line(linexEndCosTeorico, startY2, linexEndCosTeorico, endY1);
        doc.line(linexEndPrecioFact, startY2, linexEndPrecioFact, endY1);
      }
     // doc.line(linexEndOpcion, startY2, linexEndOpcion, endY1);
      doc.line(linexEndUnidad, startY2, linexEndUnidad, endY1);
      doc.line(linexEndcantidad, startY2, linexEndcantidad, endY1);
      if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
        doc.line(linexEndCosto, startY2, linexEndCosto, endY1);
      }
      // Dibujar el rectángulo
      doc.rect(startX2, startY2, endX2 - startX2, endY1 - startY2);
      doc.setDrawColor('#dbe1e8');
      doc.setLineWidth(10);
      doc.line(4.7, 15, max_X + .3, 15);
      doc.setTextColor('#3d6b87');
      doc.setFont('helvetica', 'bold');
      doc.text('Articulo', tituloArtx,lineYpagex );
      doc.text('Descripcion', tituloDescripx, lineYpagex);
      if(this.strLinea == "KIMBERLY" ||this.strLinea == "BLUE TISSUE"||this.strLinea == "TORK"){
        const tittleDes = doc.splitTextToSize('Descuento', 16);
        doc.text(tittleDes, TitulodDescuentosx, lineYpagex);
        const tittleDes1 = doc.splitTextToSize('Costo Teorico', 15);
        doc.text(tittleDes1, TituloCosTeoricox, lineYpagex-1);
        const tittleDes2 = doc.splitTextToSize('Precio Factura', 17);
        doc.text(tittleDes2, TituloPrecioFactx-2, lineYpagex-1);
      }
    //  doc.text('Opcion', titulOpcionx, lineYpagex);
      doc.text('Cantidad',titulCantidadx , lineYpagex);
      doc.text('Unidad',titulUnidadx , lineYpagex);
      if(this.strLinea != "KIMBERLY" && this.strLinea != "BLUE TISSUE" && this.strLinea != "TORK"){
        doc.text('Precio', titulCostox, lineYpagex);
      }
      
      doc.text('Importe', titulImportex, lineYpagex);
      doc.setFontSize(12);
      doc.setTextColor('#000000');
      doc.setFont('helvetica', 'bold');
      let precioporArt = 0,precioTotal = 0,impuestos=0 ;
      arrayTabla.forEach(o => {
        precioporArt =  o.dblCantidad * o.dblPrecio;
        precioTotal =  precioporArt  + precioTotal;});
      impuestos = precioTotal * 0.16;
      doc.text('Importe:', 127, endY1 + 10);
      doc.text('' + formatter.format(precioTotal)  , 152, endY1 + 10);
      // doc.text('$' + (precioTotal.toFixed(2)).toString() , 152, endY1 + 10); 
      doc.text('Impuestos:', 127, endY1 + 17);
      doc.text('' + formatter.format(impuestos) , 152, endY1 + 17);
      // doc.text('$' + (impuestos.toFixed(2)).toString(), 152, endY1 + 17);
      doc.text('Total:', 127, endY1 + 24);
       doc.text('' + formatter.format(precioTotal+impuestos) , 152, endY1 + 24);
     //  doc.text('$' + ((precioTotal+impuestos).toFixed(2)).toString(), 152, endY1 + 24); 
     let linyTopTittle = endY1 + 10;
     let linedata = linyTopTittle +13,arraySumas:any=[];

     arraySumas = this.obtenerElementosUnicos(arrayTabla);
     console.log('unidades');
     console.log(arraySumas);
     arraySumas.forEach( x => {
       arrayTabla.forEach( obj => {
       if(x.strUnidad.trim() === obj.strUnidad.trim()){
         x.intCantidad =  x.intCantidad + obj.dblCantidad
       }
       });
     });

     doc.setLineWidth(10);
     doc.setDrawColor('#dbe1e8');
     doc.line(10, linyTopTittle , 110, linyTopTittle);

     doc.setDrawColor('#000000');
     doc.setLineWidth(.2);
     doc.line(10, linedata-8 , 110, linedata-8);
   
     doc.setFontSize(7);
     doc.setFont('helvetica', 'bold');
     doc.setTextColor('#3d6b87');

     doc.text('Unidades', 28,linyTopTittle+2 );
     doc.text('Cantidades', 63, linyTopTittle+2);

     doc.setFont('helvetica', 'normal');
     doc.setTextColor('#000000');
     let textUnidadesY=linyTopTittle+10;

     textUnidadesY = textUnidadesY-2;
     linedata = linedata - 3;

   //  arraySumas = arraySumas.concat([...arraySumas,...arraySumas,...arraySumas]);
     for(let i = 0 ; i< arraySumas.length;i++){
       doc.text(arraySumas[i].strUnidad,31 ,textUnidadesY);
       doc.text(arraySumas[i].intCantidad.toString(),68 ,textUnidadesY);
       doc.line(10, linedata , 110, linedata);
       linedata= linedata+6;
       textUnidadesY =textUnidadesY +6;
       if(textUnidadesY>285 ){
       
         doc.addPage()
         textUnidadesY = 10;
         linedata = 13;
       }
     }
     if(textUnidadesY+54>285 ){
       doc.addPage()
       textUnidadesY=10;
     }else{
       textUnidadesY = textUnidadesY+ 7
     }
    // doc.addPage()
  
     doc.setDrawColor('#CFCFCF');
     doc.setLineWidth(55);
     doc.line(5, textUnidadesY+23, 200, textUnidadesY+23);
     doc.setFont('helvetica', 'bold');
     doc.text("** NOTA IMPORTANTE **",10 ,textUnidadesY);
     doc.setFont('helvetica', 'normal');
     doc.text("Favor de anexar copia de esta Orden de Compra a la Factura.",10 ,textUnidadesY+5);
     doc.text("Como parte del desarrollo de nuestros Proveedores, Ecodeli Comercial evalua los aspectos a la entrega de:",10 ,textUnidadesY+10);
     doc.text("- Cantidad,",10 ,textUnidadesY+15);
     doc.text("- Precio, ",10 ,textUnidadesY+20);
     doc.text("- Características: Coherencia entre descripción en factura y producto físico entregado,",10 ,textUnidadesY+25);
     doc.text("- Tiempo de Entrega.",10 ,textUnidadesY+30);
     doc.text("* Para productos químicos: Anexar Certificado de Calidad. ",10 ,textUnidadesY+37);
     doc.text("* Tolerancia en cantidad: mas/menos 2% ",10 ,textUnidadesY+42);
     doc.text("* HORARIO DE RECEPCIÓN DE MATERIALES: LUNES A VIERNES DE 8:30 A 13:30 HRAS.",10 ,textUnidadesY+47);
     doc.setDrawColor('#000000');
     console.log("Tamaño altura = "+ textUnidadesY+47)
    }
    console.log(proveedor);
   // doc.save(proveedor.strProveedor+'_OrdenCompra_'+OrdenC+'.pdf');

    // Guarda el PDF con un nombre temporal (por ejemplo, "orden_compra_temp.pdf")
    const nombreArchivoTemporal = proveedor.strProveedor + '_OrdenCompra_' + OrdenC + '.pdf';
    doc.save(nombreArchivoTemporal);

    // Convierte el archivo PDF a un objeto Blob
    const archivoPDF = new Blob([doc.output('blob')], { type: 'application/pdf' });

    // Crea un formulario FormData y agrega el archivo PDF
    const formData = new FormData();
    formData.append('archivo', archivoPDF, nombreArchivoTemporal);
    this.fnAnexoMov(formData);

    /*// Obtiene la URL del archivo PDF generado
    const urlPDF = window.URL.createObjectURL(doc.output('blob'));

    // Crea el enlace "mailto" con el PDF adjunto
    const destinatario = 'juan.desarrollo@ecodeli.com';
    const asunto = 'Asunto del correo';
    const cuerpo = 'Cuerpo del correo adjunto';
    const enlaceMailto = `mailto:${destinatario}?subject=${encodeURIComponent(asunto)}&body=${encodeURIComponent(cuerpo)}&attachment=${urlPDF}`;

    // Abre el cliente de correo predeterminado con el PDF adjunto
    window.location.href = enlaceMailto;*/

  }
  fnAnexoMov( form:any){ 
    this._httpService.setAnexMov(form).subscribe( resultados => {  
      console.log(resultados);
    });  


  }
  obtenerElementosUnicos(array:any): any[] {
    // Creamos un nuevo array vacío para almacenar los elementos únicos
    const elementosUnicos: any[] = [];
    // Iteramos sobre cada objeto en miArray
    array.forEach((objeto) => {
      // Comprobamos si el objeto actual ya existe en el array de elementos únicos
      const existe = elementosUnicos.some((elemento) => elemento.strUnidad.trim() === objeto.strUnidad.trim());

      // Si el objeto no existe en el array de elementos únicos, lo agregamos
      if (!existe) {
        elementosUnicos.push({strUnidad:objeto.strUnidad,intCantidad:0});
      }
    });
    return elementosUnicos;
  }


  /********************F*I*N********************P**D**F************************************************* */
  fnEliminar(strAlm: number, v: number) {
    this.arrayEncabezados.forEach(element => {
      if (element.strAlmacen == strAlm) {
        element.arrayresult.splice(v, 1)
      }
    });
  }
  formatDescripcion(descripcion: string): string { // Agregar el salto de línea en la posición deseada
    const posicionSalto = Math.floor(descripcion.length / 2);
    const descripcionFormateada = `${descripcion.slice(0, posicionSalto)}<br>${descripcion.slice(posicionSalto)}`;
    return descripcionFormateada;
  }
  tieneRegistros(almOrigen: string, almDestino: string): boolean {
    return this.arrayCuerpo.some(registro =>
      registro.strAlm_Origen === almOrigen && registro.strAlm_destino === almDestino
    );
  }
  fnUnificar(strAlmacen: number, strNombreAlm: string, strProveedor: string) {
    console.log(strAlmacen, strNombreAlm);
    let arrayObjPasar = this.arrayEncabezados.filter(o => o.strNombreAlm == strNombreAlm && o.strProveedor == strProveedor).map(o => o.arrayresult).flat();
    this.arrayEncabezados.forEach((obj) => {
      if (obj.strAlmacen == strAlmacen && obj.strProveedor == strProveedor) {
        obj.arrayresult.push(...arrayObjPasar);
        const newStrAlmacen = obj.arrayresult[0].strAlm_Origen;
        const newStrAlmacenNombre = obj.arrayresult[0].strAlm_OrigenNombre;
        obj.arrayresult.forEach((item) => {
          item.strAlm_Origen = newStrAlmacen;
          item.strAlm_OrigenNombre = newStrAlmacenNombre;
        });
      }
    });
    this.arrayEncabezados.forEach((obj) => {
      if (obj.strNombreAlm === strNombreAlm && obj.strProveedor == strProveedor) {
        obj.arrayresult = [];
      }
    });
  }
 
  fnsumarCantidadtotales(): number {
    let suma = 0;
    if (this.arrayEncabezados) {
      const objetosConArrayResult = this.arrayEncabezados.filter(objeto => objeto.arrayresult !== undefined && objeto.arrayresult.length > 0);
      if (objetosConArrayResult) {
        const arrayResultFinal = objetosConArrayResult.reduce((resultado, objeto) => resultado.concat(objeto.arrayresult), []);
        suma = arrayResultFinal.reduce((acumulador, registro) => acumulador + registro.dblCantidad, 0);
      }
    }
    return suma;
  }
  fnsumarpesostotales(): number {
    let suma = 0;
    if (this.arrayEncabezados) {
      const objetosConArrayResultparatotales = this.arrayEncabezados.filter(objeto => objeto.arrayresult !== undefined && objeto.arrayresult.length > 0);
      if (objetosConArrayResultparatotales) {
  
        const arrayResultFinalMon = objetosConArrayResultparatotales.reduce((resultado, objeto) => resultado.concat(objeto.arrayresult), []);
        suma = arrayResultFinalMon.reduce((acumulador, registro) => acumulador + (registro.dblPrecio * registro.dblCantidad), 0);
      }
    }
    return suma;
  }
  exportToExcel() {
    let array1 = [];
    if (this.arrayEncabezados) {
      const objetosConArrayResult = this.arrayEncabezados.filter(objeto => objeto.arrayresult !== undefined && objeto.arrayresult.length > 0);
      array1 = objetosConArrayResult;
    }
    let array = [];
    array1.forEach(element => {
      /*  let obj1 = {
         strAlm_OrigenNombre: element.strNombreAlm || '',
         strAlm_destinoNombre: '',
         strArticulo:  '',
         strOpcion: '', 
         strUnidad:'',
         dblCantidad: '',
         dblVolumen:  '',
         dblPeso:  ''
       };
       array.push(obj1)  */
      element.arrayresult.forEach(ele => {
        let obj = {
          strAlm_OrigenNombre: element.strNombreAlm || '',
          strAlm_destinoNombre: ele.strAlm_destinoNombre || '',
          strArticulo: ele.strArticulo || '',
          strOpcion: ele.strOpcion || '',
          strUnidad: ele.strUnidad || '',
          dblCantidad: ele.dblCantidad || '',
          dblVolumen: ele.dblVolumen || '',
          dblPeso: ele.dblPeso || ''
        };
        array.push(obj)
      });
      let obj2 = {
        strAlm_OrigenNombre: '',
        strAlm_destinoNombre: '',
        strArticulo: '',
        strOpcion: '',
        strUnidad: '',
        dblCantidad: '',
        dblVolumen: '',
        dblPeso: ''
      };
      array.push(obj2)
    });
    let obj3 = {
      strAlm_OrigenNombre: 'Total',
      strAlm_destinoNombre: '',
      strArticulo: '',
      strOpcion: '',
      strUnidad: '',
      dblCantidad: this.fnsumarCantidadtotales(),
      dblVolumen: '',
      dblPeso: ''
    };
    array.push(obj3)
    console.log(array)
    let columns = [
      { header: 'Origen', key: 'strAlm_OrigenNombre' },
      { header: 'Destino', key: 'strAlm_destinoNombre' },
      { header: 'Articulo', key: 'strArticulo' },
      { header: 'Opcion', key: 'strOpcion' },
      { header: 'Unidad', key: 'strUnidad' },
      { header: 'Cantidad', key: 'dblCantidad' },
      { header: 'Volumen', key: 'dblVolumen' },
      { header: 'Peso', key: 'dblPeso' }
    ];
     this._excelService.exportASExcelFile('Planeador Compras', '', columns, array, [], 'PlaneadorCompras', 'Compras');
  }
  fnLimpiarModal(){

    this.arrayBusquedaArt=[];

    this.strBuscar = "";

  }

  exportToExceljson(jsonDatas: any[], sheetName: string, title: string) {
/*     const nombresUnicos = [...new Set(jsonDatas.map(item => item.strEstatusxAlm))];
    console.log(nombresUnicos)
    let arrayPorExcel = [];
    for(let i = 0; i<nombresUnicos.length; i++){
      arrayPorExcel = [];
      jsonDatas.forEach(x => {
       if( nombresUnicos[i] == x.strEstatusxAlm){
        arrayPorExcel.push(x);
       }
    });
    let array1:any[] = arrayPorExcel;
    let array = [];
    let total = 0,arrayLeng=0;
    array1.forEach(ele => {
        let obj = {
          Clave: ele.strClaveFabricante || '',
          Cantidad: ele.dblCantidad || '',
          Precio: ele.dblPrecio || '',
          Total: (ele.dblPrecio*ele.dblCantidad) || '',
          Convenio: ele.strEstatusxAlm,//ele.strUnidad || ''
          totales:''
        };
        array.push(obj)
        total = total +(ele.dblPrecio*ele.dblCantidad);
    });
    arrayLeng = array.length -1;
    array[arrayLeng].totales=  total;
    let columnasMonedas=['Precio','Total','totales']
    let columns = ['Clave', 'Cantidad', 'Precio', 'Total', 'Convenio',''];
  this._excelService.exportASExcelFile(title, '', columns, array, [], sheetName+' Conv:'+nombresUnicos[i], 'Compras',columnasMonedas); 
    console.log(arrayPorExcel);
    } */
     let array1:any[] = jsonDatas;
    let array = [];
    let total = 0,arrayLeng=0;
    array1.forEach(ele => {
        let obj = {
          Clave: ele.strClaveFabricante || '',
          Cantidad: ele.dblCantidad || '',
          Precio: ele.dblPrecio || '',
          Total: (ele.dblPrecio*ele.dblCantidad) || '',
          Convenio: ele.strEstatusxAlm || '',
          totales:''
        };
        array.push(obj)
        total = total +(ele.dblPrecio*ele.dblCantidad);
    });
    arrayLeng = array.length -1;
    array[arrayLeng].totales=  total;
    let columnasMonedas=['Precio','Total','totales']
    console.log(array);
    let columns = [
      { header: 'Clave', key: 'Clave' },
      { header: 'Cantidad', key: 'Cantidad' },
      { header: 'Precio', key: 'Precio' },
      { header: 'Total', key: 'Total' },
      { header: 'Convenio', key: 'Convenio' },
      { header: '', key: 'totales' } // Si deseas mostrar los totales al final
    ];
    this._excelService.exportASExcelFile(title, '', columns, array, [], sheetName + "Conv:"+array1[0].strEstatusxAlm, 'Compras',columnasMonedas); 
  }


}
